module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.137bb088.svg";